import { Select, Option } from "@material-tailwind/react";
import { Controller } from "react-hook-form";
import { getValidationErrors } from "./common";

export interface SelectFormOptionProp {
    label: string;
    value: number | string;
    disabled?: boolean | false;
}
interface SelectFormProps {
    label: string;
    control: any;
    options: SelectFormOptionProp[];
    errors?: any;
    enabled?: boolean;
    field: string;
    visible?: boolean;
    rules?: any;
    className?: string;
}

export function SelectForm({
    label,
    control,
    options,
    errors = null,
    enabled = true,
    field,
    visible = true,
    rules = {},
    className = "",
}: SelectFormProps) {

    const validationError = errors && getValidationErrors(errors, field, label, rules);

    const getRules = () => {
        if (!visible && rules) {
            rules['required'] = false;
        }
        return rules;
    };

    const getOptionElement = (option: SelectFormOptionProp) => {
        return (
            <Option value={`${option?.value}`} key={option?.value} disabled={option.disabled}>
                {option?.label || '[..]'}
            </Option>
        );
    }

    const getOptions = () => {
        return options.map((option) => getOptionElement(option));
    }

    return visible ? (
        <div className={"" + className}>
            <Controller
                name={field}
                control={control}
                rules={getRules()}
                render={({ field, fieldState }) => (
                    <Select
                        label={label}
                        disabled={!enabled}
                        size="lg"
                        placeholder=''
                        error={fieldState.invalid}
                        hidden={!visible}
                        children={getOptions()}
                        onChange={(e) => {
                            field.onChange(e);
                        }}
                    />
                )}
            />
            <label className='label-input-error'> {validationError ? (validationError) : ("")}</label>
        </div>
    ) : null;
}